// import React from 'react';
// import FirebaseIcon from 'mdi-react/FirebaseIcon';
// import withAuthFirebase from '@/shared/components/account/auth/withAuthFirebase';
import LogInForm from '@/shared/components/account/loginForm/LogInForm';
import {
    AccountCard,
    AccountContent,
    AccountHead,
    AccountLogo,
    AccountLogoAccent,
    // AccountOr,
    // AccountSocial,
    // AccountSocialButtonAuth0,
    // AccountSocialButtonFirebase,
    AccountTitle,
    AccountWrap,
} from '@/shared/components/account/AccountElements';
// import GoogleAuthBtn from '../AuthBtn/googleAuthBtn';
// import FacebookAuthBtn from '../AuthBtn/fbAuthBtn';
// import MetaMaskAuthBtn from '../AuthBtn/metaMaskAuthBtn';
// import MicrosoftAuthBtn from '../AuthBtn/microsoftAuthBtn';
// import WalletConnectAuthBtn from '../AuthBtn/walletConnectAuthBtn';

// const auth0Icon = `/img/auth0.svg`;

const LogIn = () => (
    // { changeIsOpenModalFireBase }:{changeIsOpenModalFireBase:()=>void}
    <AccountWrap>
        <AccountContent>
            <AccountCard>
                <AccountHead>
                    <AccountTitle>
                        Welcome to
                        <AccountLogo>
                            {' '}
                            Har
                            <AccountLogoAccent>monea</AccountLogoAccent>
                        </AccountLogo>
                    </AccountTitle>
                    <h4 className="subhead">Your AI mental health companion</h4>
                </AccountHead>
                <LogInForm />
                {/* <AccountOr>
                    <p>Or Easily Using</p>
                </AccountOr> */}
                {/* <AccountSocial>
                    <FacebookAuthBtn />
                    <GoogleAuthBtn />
                    <MicrosoftAuthBtn />
                    <AccountSocialButtonFirebase variant="secondary" onClick={changeIsOpenModalFireBase}>
                        <FirebaseIcon />
                    </AccountSocialButtonFirebase>
                    <MetaMaskAuthBtn />
                    <WalletConnectAuthBtn />
                </AccountSocial> */}
            </AccountCard>
        </AccountContent>
    </AccountWrap>
);

export default LogIn;
// withAuthFirebase(

// );
